var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Confirm',{attrs:{"message":"このユーザをすべての端末からサインアウトさせます。よろしいですか？"},on:{"on-click-yes":_vm.signOut},scopedSlots:_vm._u([{key:"default",fn:function({ on }){return [_c('ActionButton',_vm._g({attrs:{"btn-value":"サインアウト","icon":"mdi-logout-variant"}},on))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }